module.exports = __webpack_public_path__ + "img/6_69.c7b0d0a8.png";